export default __webpack_public_path__ + "static/media/picDungTran.3e629475.png";